import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { ICmsOutletBlockComponent } from '../../../catalog/outlet-block/icms-outlet-block.component';
import { PageViewAbstract } from '../../../catalog/page/view/page-view.abstract';
import { iconsOptions } from '../../../styles/cms.config';
import { NCmsIndexedText } from '../../indexed-text/cms-indexed-text.component';
import { NCmsSection } from '../../section/cms-section.component';
import { NCmsInformationFaq } from '../components/faq/cms-information-faq.component';
import { NCmsImageGrid } from '../components/image-grid/cms-image-grid.component';
import { NCmsInformationTiles } from '../components/tiles/cms-information-tiles.component';
import { INFORMATION_TAB } from '../root-page/cms-information-root-page.component';

declare module '@df/catalog/cms/cms-model.interface' {
    export interface IPageDataV3 {
        components: NICmsContentComponent.IData[];
    }
}

export interface ICmsAdditionalMeta {
    [key: string]: any;
}

export namespace NInformationPageType {
    export const typeId = 'information-page';

    export interface ITypeData {
        icon: string;
        topCopy?: string;
        useBackArrow?: boolean;
        showTitle?: boolean;
    }
}

@ICmsPageType({
    id: NInformationPageType.typeId,
    title: 'Information page',
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            title: 'Icon',
            key: 'typeData.icon',
            itemName: 'icon',
            tab: INFORMATION_TAB,
            options: iconsOptions,
            previewMode: 'icon',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.showTitle',
            title: 'Show title',
            tab: INFORMATION_TAB,
            default: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'typeData.topCopy',
            title: 'Top copy',
            tab: INFORMATION_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.useBackArrow',
            title: 'Use back arrow',
            default: true,
            tab: INFORMATION_TAB
        }
    ],
    /**
     * Only allow parent page to be information-category
     */
    parentFilter: page => {
        return page.rawData?.pageType === NInformationPageType.typeId;
    }
})
@Component({
    selector: 'cms-information-page',
    templateUrl: './cms-information-page.html',
    styleUrl: './cms-information-page.scss',
    imports: [ICmsClientModule, ICmsOutletBlockComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsInformationPageComponent extends PageViewAbstract implements OnChanges {
    @Input()
    data: IPageDataV3 | undefined;

    @Input()
    @ICmsContent({
        watchDepth: 1
    })
    typeData: NInformationPageType.ITypeData | undefined;

    readonly allowedComponents = [
        'text',
        'html',
        NCmsSection.componentId,
        NCmsInformationTiles.componentId,
        NCmsIndexedText.componentId,
        NCmsInformationFaq.componentId,
        NCmsImageGrid.componentId
    ];

    protected get components(): NICmsContentComponent.IData[] {
        return this.data?.components || [];
    }

    protected get name(): string {
        return this.data?.name || '';
    }
}
